import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

const DatePick = (props) => {
  const id = JSON.stringify(props.id);
  return (
    <div style={{ marginTop: 20 }}>
      <div style={{}}>
        <DatePicker
          style={{
            width: "80%",
            height: 45,
            fontSize: 14,
            padding: 10,
            borderWidth: 1,
            borderColor: "#000",
            borderRadius: 5,
          }}
          size="large"
          mode="date"
          className="custom-date-picker"
          format={"YYYY-MM-DD"}
          // value={props.values[props.id]}
          value={props.values[props.id] ? moment(props.values[props.id], "YYYY-MM-DD") : ""}
          placeholder={props.name}
          onChange={(date) => {
            props.setValues({
              ...props.values,
              [props.id]: date.format("YYYY-MM-DD"),
            });
          }}
          onBlur={props.handleBlur(id)}
        />
      </div>
    </div>
  );
};

export default DatePick;
